import React, { useState, useEffect} from 'react'
import { makeAutoObservable } from 'mobx'
import { useStore, observer } from '@/hooks/storeHooks'
import st from './index.scss'
import cn from 'classnames'

class AddressStore {
  constructor() {
    makeAutoObservable(this)
  }

  isDefault = false;
  // 添加地址表单数据
  addressForm = {
    contacts: {
      label: "收件人姓名",
      value: "",
      errorMsg: "",
      verify: () => {
        let errMsg = "";
        if (this.addressForm.contacts.value == "") {
          errMsg = "请输入您的姓名";
        } else {
          errMsg = "";
        }

        this.addressForm.contacts.errorMsg = errMsg;

        // 校验是否通过
        return errMsg ? false : true;
      },
      Change: (e) => {
        let value = e.target.value;
        this.addressForm.contacts.value = value;
      },
    },
    phone: {
      label: "联系方式",
      value: "",
      errorMsg: "",
      verify: () => {
        let errMsg = "";
        if (this.addressForm.phone.value == "") {
          errMsg = "请填写您的联系方式";
        } else if (
          this.addressForm.phone.value.length >= 11 &&
          /^(12|13|14|15|16|17|18|19)[0-9]{9}$/.test(
            this.addressForm.phone.value
          )
        ) {
          errMsg = "";
        } else {
          errMsg = "请输入正确的手机号";
        }

        this.addressForm.phone.errorMsg = errMsg;

        // 校验是否通过
        return errMsg ? false : true;
      },
      Change: (e) => {
        let value = e.target.value;
        this.addressForm.phone.value = value;
      },
    },
    address: {
      label: "地址",
      provinceCode: "",
      cityCode: "",
      districtCode: "",
      provinceErrMsg: "", // 省错误信息
      cityErrMsg: "", // 市错误信息
      regionErrMsg: "", // 区错误信息
      verify: (type, errType) => {
        console.log(type, errType);
        let errMsg = '';
        if (this.addressForm.address[type] == "") {
          if (errType == "provinceErrMsg") {
            errMsg = "请选择省地址";
          } else if (errType == "cityErrMsg") {
            errMsg = "请选择市地址";
          } else {
            errMsg = "请选择区地址";
          }
        } else {
          errMsg = "";
        }

        this.addressForm.address[errType] = errMsg;

        // 校验是否通过
        return this.addressForm.address[type] == "" ? false : true;
      },
      Change: (e, type, errType) => {
        let value = e.target.value;
        if (!value) return;

        this.addressForm.address[type] = value;

        console.log(this.addressForm.address[type])

        // 校验
        this.addressForm.address.verify(type, errType);

        if (type == "provinceCode") {
          // 选择省获取市地址
          // 获取市地址
          this.getAnalysisRegionVo(
            value,
            "cityList",
            "cityCode",
            (code) => {
              // 获取区
              this.getAnalysisRegionVo(
                code,
                "regionList",
                "districtCode"
              );
            }
          );
        } else if (type == "cityCode") {
          // 选择市获取区地址
          // 获取下级地址
          this.getAnalysisRegionVo(
            value,
            "regionList",
            "districtCode"
          );
        }
      },
    },
    detail: {
      label: "详细地址",
      value: "",
      errorMsg: "",
      verify: () => {
        let errMsg = "";
        if (this.addressForm.detail.value == "") {
          errMsg = "请填写您的详细地址";
        } else {
          errMsg = "";
        }

        this.addressForm.detail.errorMsg = errMsg;

        // 校验是否通过
        return errMsg ? false : true;
      },
      Change: (e) => {
        let value = e.target.value;
        this.addressForm.detail.value = value;
      },
    },
  };
  provinceList = []; // 省
  cityList = []; // 市
  regionList = []; // 区
  getAnalysisRegionVo = () => { }

  // 修改状态
  addAddressCommonChange = (key, value) => {
    this[key] = value
  }

  // 修改地址信息
  changeAddress = (key, value) => {
    this.addressForm.address[key] = value;
  }

  // 修改状态
  changeEchoCity = ({
    contacts,
    phone,
    provinceCode,
    cityCode,
    districtCode,
    detail,
    isDefault,
  }) => {
    this.addressForm.contacts.value = contacts;
    this.addressForm.phone.value = phone;
    this.addressForm.address.provinceCode = provinceCode;
    this.addressForm.address.cityCode = cityCode;
    this.addressForm.address.districtCode = districtCode;
    this.addressForm.detail.value = detail;
    this.isDefault = isDefault;
  }
}



// 添加修改地址
/**
 * closePopUp：弹框
 * addressPopUpInfo: { 地址信息  (固定这几个参数, 传该参数为编辑地址, 否则新建) 
 *    contacts: data.contacts,
 *    phone: data.phone,
 *    provinceCode: data.provinceCode,
 *    cityCode: data.cityCode,
 *    districtCode: data.districtCode,
 *    detail: data.detail,
 *    isDefault: data.isDefault,   // 是否默认地址
 * } 
 * AddressAddSuccess：添加成功回调
 */
export default observer(function Address({ closePopUp, addressPopUpInfo, AddressAddSuccess, ...rest }) {
  console.log(addressPopUpInfo)
  let [store] = useState(() => new AddressStore())
  const { addAddressCommonChange, changeEchoCity, changeAddress, addressForm, provinceList, cityList, regionList, isDefault } = store;
  const contacts = addressForm.contacts;
  const address = addressForm.address;
  const phone = addressForm.phone;
  const detail = addressForm.detail;
  const { user, api } = useStore()
  console.log(contacts, address, phone, detail)

  useEffect(() => {
    addAddressCommonChange('getAnalysisRegionVo', getAnalysisRegionVo);
    // 获取省
    getCityOneList();
  }, [])

  /**
   * code: 地区编码
   * listName：省市区数组key值
   * valueName：省市区绑定属性key值
   * callback：获取省市区之后的回调函数
   * */
  function getAnalysisRegionVo(code, listName, valueName, callback) {
    user.post(api.mokao_getAnalysisRegionVo, {
      regionCode: code,
    }).then(ret => {
      addAddressCommonChange(listName, ret.data)
      changeAddress(valueName, ret.data?.[0]?.regionCode)
      callback ? callback(ret.data?.[0]?.regionCode) : "";
    })
  }

  //获取城市一级列表
  function getCityOneList() {
    user.post(api.mokao_get_classa_parent, {}).then(ret => {
      addAddressCommonChange('provinceList', ret.data);
      // 编辑地址 回显
      if (addressPopUpInfo) {
        echoCity(addressPopUpInfo);
      }
    })
  }


  // 回显省市区
  function echoCity(data) {
    // 获取市地址
    getAnalysisRegionVo(
      data.provinceCode,
      "cityList",
      "cityCode",
      (code) => {
        // 获取区
        getAnalysisRegionVo(
          data.cityCode,
          "regionList",
          "districtCode",
          () => {
            // 回显地址
            changeEchoCity({
              contacts: data.contacts,
              phone: data.phone,
              provinceCode: data.provinceCode,
              cityCode: data.cityCode,
              districtCode: data.districtCode,
              detail: data.detail,
              isDefault: data.isDefault,
            })
          }
        );
      }
    );
  }


  // 收货地址表单提交
  function submitAddressForm() {
    let contactsVerify = contacts.verify();
    let phoneVerify = phone.verify();
    let provinceVerify = address.verify(
      "provinceCode",
      "provinceErrMsg"
    );
    let cityVerify = address.verify(
      "cityCode",
      "cityErrMsg"
    );
    let regionVerify = address.verify(
      "districtCode",
      "regionErrMsg"
    );
    let detailVerify = detail.verify();

    if (
      contactsVerify &&
      phoneVerify &&
      provinceVerify &&
      cityVerify &&
      regionVerify &&
      detailVerify
    ) {

      AddressAddSuccess({
        contacts: contacts.value,
        phone: phone.value,
        provinceCode: address.provinceCode,
        cityCode: address.cityCode,
        districtCode: address.districtCode,
        detail: detail.value,
        isDefault: isDefault,
        isEdit: addressPopUpInfo ? true : false,
      });
    }
  }


  return (
      <div className={cn(st['addressPopUpBox'], rest.className)}>
        <div className={st['addressPopUpTitle']}>
          <div>
            {addressPopUpInfo
              ? "编辑收货地址"
              : "添加收货地址"}
          </div>
          <img
            onClick={() => {
              closePopUp();
            }}
            src="https://osscdn.zhongheschool.com/mallP2_2022_6_16/pc/createOrder/close.png"
            alt=""
          />
        </div>

        <div className={st['addressForm']}>
          <div
            className={
              cn({
                [st['addressFormItem']]: true,
                [st['errMsg']]: contacts?.errorMsg
              })
            }
          >
            <div className={st['addressFormItemCon']}>
              <div className={st['addressFormLable']}>收件人姓名</div>
              <div className={st['addressFormValue']}>
                <input
                  placeholder="请填写您的姓名"
                  onBlur={(e) => {
                    contacts.verify(e);
                  }}
                  onChange={(e) => {
                    contacts.Change(e);
                  }}
                  value={contacts.value}
                  type="text"
                />
              </div>
            </div>
            <div className={st['errMsgText']}>{contacts?.errorMsg}</div>
          </div>
          <div
            className={
              cn({
                [st['addressFormItem']]: true,
                [st['errMsg']]: phone.errorMsg
              })
            }
          >
            <div className={st['addressFormItemCon']}>
              <div className={st['addressFormLable']}>联系方式</div>
              <div className={st['addressFormValue']}>
                <input
                  placeholder="请填写您的联系方式"
                  onBlur={(e) => {
                    phone.verify(e);
                  }}
                  onChange={(e) => {
                    phone.Change(e);
                  }}
                  value={phone.value}
                  type="text"
                />
              </div>
            </div>
            <div className={st['errMsgText']}>{phone.errorMsg}</div>
          </div>
          <div className={st['addressFormItem']}>
            <div className={st['addressFormItemCon']}>
              <div className={st['addressFormLable']}>地址</div>
              <div className={cn({
                [st['addressFormValue']]: true,
                [st['addressFormSelect']]: true
              })}>
                <div
                  className={
                    cn({
                      [st['addressFormValueSelect']]: true,
                      [st['errMsg']]: address.provinceErrMsg
                    })
                  }
                >
                  <select
                    value={address.provinceCode}
                    placeholder="请输入省"
                    onChange={(e) => {
                      address.Change(e, "provinceCode", "provinceErrMsg");
                    }}
                  >
                    <option value="">请输入省</option>
                    {
                      // 获取省地址
                      provinceList?.map((ele, index) => {
                        return (
                          <option key={index} value={ele.regionCode}>
                            {ele.regionName}
                          </option>
                        );
                      })
                    }
                  </select>
                  <div className={st['errMsgText']}>{address.provinceErrMsg}</div>
                </div>
                <div
                  className={
                    cn({
                      [st['addressFormValueSelect']]: true,
                      [st['errMsg']]: address.cityErrMsg
                    })
                  }
                >
                  <select
                    value={address.cityCode}
                    placeholder="请输入市"
                    onChange={(e) => {
                      address.Change(e, "cityCode", "cityErrMsg");
                    }}
                  >
                    <option value="">请输入市</option>
                    {
                      // 获取市地址
                      cityList?.map((ele, index) => {
                        return (
                          <option key={index} value={ele.regionCode}>
                            {ele.regionName}
                          </option>
                        );
                      })
                    }
                  </select>
                  <div className={st['errMsgText']}>{address.cityErrMsg}</div>
                </div>
                <div
                  className={
                    cn({
                      [st['addressFormValueSelect']]: true,
                      [st['errMsg']]: address.regionErrMsg
                    })
                  }
                >
                  <select
                    value={address.districtCode}
                    placeholder="请输入区"
                    onChange={(e) => {
                      address.Change(e, "districtCode", "regionErrMsg");
                    }}
                  >
                    <option value="">请输入区</option>
                    {
                      // 获取区地址
                      regionList?.map((ele, index) => {
                        return (
                          <option key={index} value={ele.regionCode}>
                            {ele.regionName}
                          </option>
                        );
                      })
                    }
                  </select>
                  <div className={st['errMsgText']}>{address.regionErrMsg}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              cn({
                [st['addressFormItem']]: true,
                [st['errMsg']]: detail.errorMsg
              })
            }
          >
            <div className={st['addressFormItemCon']}>
              <div className={st['addressFormLable']}>详细地址</div>
              <div className={st['addressFormValue']}>
                <input
                  placeholder="请填写您的详细地址"
                  onBlur={(e) => {
                    detail.verify(e);
                  }}
                  onChange={(e) => {
                    detail.Change(e);
                  }}
                  value={detail.value}
                  type="text"
                />
              </div>
            </div>
            <div className={st['errMsgText']}>{detail.errorMsg}</div>
          </div>
        </div>

        <div
          className={st['setDefaultAddress']}
          onClick={
            () => {
              addAddressCommonChange('isDefault', !isDefault);
            }
          }
        >
          <div className={st['selectBox']}>
            {isDefault ? (
              <div className={st['select_yes']}></div>
            ) : (
              <div className={st['select_no']}></div>
            )}
          </div>
          <p>将此地址设置为默认收货地址</p>
        </div>

        <div className={st['addressBtn']}>
          <button
            className={st['cancel']}
            onClick={() => {
              closePopUp()
            }}
          >
            取消
          </button>
          <button
            className={st['confirm']}
            onClick={() => {
              submitAddressForm();
            }}
          >
            确定
          </button>
        </div>
      </div>
  )
})